module.exports = __webpack_public_path__ + "img/consejo.2b5224c5.png";